import { MEDIA_BLOG_SHOWCASE_TEAM_ID } from "shared/pages/exploreHseContextsNew/const/misc"

export const getEnableFeedParam = (teamId: string, mainTab: Record<string, any>) => {
    const isMainFilter = mainTab?.path === 'all';

    if (teamId === MEDIA_BLOG_SHOWCASE_TEAM_ID && isMainFilter) {
        return { enableFeed: true }
    }
    return {}
}import { MEDIA_BLOG_SHOWCASE_TEAM_ID } from "shared/pages/exploreHseContextsNew/const/misc"

export const getEnableFeedParam = (teamId: string, mainTab: Record<string, any>) => {
    const isMainFilter = mainTab?.path === 'all';

    if (teamId === MEDIA_BLOG_SHOWCASE_TEAM_ID && isMainFilter) {
        return { enableFeed: true }
    }
    return {}
}